const merchandiseCredit = {
  merchandiseCredit: {
    noFile: 'Nenhum arquivo selecionado',
    fileName: 'Nome do arquivo',
    software_service: 'Serviço de software',
    hardware_product: 'Produto de Hardware',
    sampleFileNameUS: 'Crédito de mercadoria nos EUA',
    sampleFileNameAU: 'Crédito de mercadoria AU',
    sampleFileNameNL: 'Crédito de mercadoria NL',
    sampleFileNameBE: 'Crédito de mercadoria BE',
    sampleFileNameMX: 'Crédito de mercadoria MX',
    rowNumber: 'Número da linha',
    errorMessage: 'Mensagem'
  }
};

export default merchandiseCredit;
